import Session from '@netx/core/lib/netx-session';
import {useSessionStore} from '@netx/core-auth-next/store';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {setGlobal} from '@netx/core-next/utils/setGlobal';

export const session = new Session();

// we will import the store for now and keep it up to date
// this eliminates the need for the the store to import this _singleton_ file
// which, as noted below, brings along A LOT of baggage
session.on('change reset sync', () => {
	useSessionStore.setState({
		isAuthorized: session.authenticated(),
		isLoggedInAsOtherUser: session.get('loggedInAsOtherUser'),
		isPublicUser: session.isAuthenticatedAsPublicUser(),
		isToken: session.getToken() ? true : false,
		key: (session.getToken() ? session.getToken() : session.getKey()) || null,
		publicMethods: session.get('publicMethods') || [],
	});
});

import {userProfile} from '@netx/core-user/collections/singletons/userProfile';

userProfile.on('change reset sync', () => {
	useSessionStore.setState({
		isPublicUser: session.isAuthenticatedAsPublicUser(),
	});
});

// hack for not having to import this file, and in return the model, which imports the netx-model/netx-collection which has
// so much baggage
dispatcher.on('session:reset:logout:timer', () => {
	session.resetLogoutTimer();
});

setGlobal({session});

export default session;
